import Typography from '@mui/material/Typography';

export default function DetailsContent({children,...props}) {
    return (                
        <Typography variant="body2">{children}</Typography>    
    )
}